// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '0531dd45-1420-4690-abf4-34eb39bc116b',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'cfef42aa-72e0-4e5c-8692-3b9888d0dcb6',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.289855,
        y: 0.333333
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster',
      parent: '0531dd45-1420-4690-abf4-34eb39bc116b',
      data: {
        maxSize: 80
      }
    },
    {
      id: '5d1ca83f-ea4b-4f8a-84c4-f5c6ec6a44d0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 0.3,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Point_Bubble',
      parent: '0531dd45-1420-4690-abf4-34eb39bc116b'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  handleResize: false
} as const;

export class ItemRewardBubbleLayout {
  static raw = raw;
  root!: Container;
  icon!: Sprite & { data: typeof raw['list'][1]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
